import { Tooltip } from "@material-ui/core";
import { memo } from "react";

import MarkerLiveUnit from "@/assets/img/map/MarkerLiveUnit.svg";
import { useStyles } from "@/common/components/MapLandingPage/Map/LiveUnitMarker/LiveUnitMarkerStyles";

import { MarkerProps } from "../types";


const LiveUnitMarker: React.FC<MarkerProps> = ({ lat, lng, text, unitId, onClick }) => {
    const classes = useStyles();

    return (
        <Tooltip title={text} classes={{ popper: classes.tooltip }}>
            <div className={classes.marker} onClick={() => onClick({ unitId, lat, lng, text })}>
                <img src={MarkerLiveUnit} alt="Live Unit" />
            </div>
        </Tooltip>
    );
};

export default memo(LiveUnitMarker);
